import { Filter, RotateCcw } from "lucide-react";
import PropTypes from "prop-types";
import Drawer from "@src/@core/components/ui-components/drawer";
import Select from "@components/ui-components/select";
import { PLATFORM_OPTIONS } from "@src/utility/constants/panel/common";
import { COUNTRY_OPTIONS } from "../misc/constants";
import useBrandsFilterDrawer from "../hooks/use-brands-filter-drawer";

export const BrandsFilterTrigger = ({ activeCount, onClick }) => (
    <button
        type="button"
        onClick={onClick}
        className="inline-flex h-10 items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 text-sm font-medium text-gray-700 hover:bg-gray-50">
        <Filter className="h-4 w-4" />
        Filters
        {activeCount > 0 && (
            <span className="flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1 text-[11px] font-semibold text-white">
                {activeCount}
            </span>
        )}
    </button>
);

BrandsFilterTrigger.propTypes = {
    activeCount: PropTypes.number,
    onClick    : PropTypes.func.isRequired
};

const BrandsFilterDrawer = ({ open, filters, onClose, onApply }) => {
    const { draft, setField, handleApply, handleClear } = useBrandsFilterDrawer({ open, filters, onClose, onApply });

    return (
        <Drawer
            open={open}
            onClose={onClose}
            title="Filter brands"
            subtitle="Narrow results by country, platform or model."
            footer={(
                <>
                    <button
                        type="button"
                        onClick={handleClear}
                        className="inline-flex items-center gap-1.5 text-sm font-medium text-muted transition-colors hover:text-gray-700">
                        <RotateCcw className="h-3.5 w-3.5" />
                        Clear all
                    </button>
                    <button
                        type="button"
                        onClick={handleApply}
                        className="rounded-lg bg-primary px-4 py-2.5 text-sm font-medium text-white shadow-sm transition-colors hover:bg-primary/90">
                        Apply filters
                    </button>
                </>
            )}>
            <div>
                <div className="py-5">
                    <div className="mb-3 text-xs font-semibold uppercase tracking-wide text-muted">Country</div>
                    <Select
                        id="country-filter"
                        className="w-full"
                        placeholder="Any country"
                        value={draft.country}
                        options={COUNTRY_OPTIONS}
                        onChange={setField("country")} />
                </div>

                <div className="py-1">
                    <div className="mb-3 text-xs font-semibold uppercase tracking-wide text-muted">Platform</div>
                    <Select
                        id="platform-filter"
                        className="w-full"
                        placeholder="Any platform"
                        value={draft.platform_name}
                        options={PLATFORM_OPTIONS}
                        onChange={setField("platform_name")} />
                </div>

                {/* <div className="py-5">
                    <div className="mb-3 text-xs font-semibold uppercase tracking-wide text-muted">Payment model</div>
                    <Select
                        id="payment-model-filter"
                        className="w-full"
                        placeholder="Any model"
                        value={draft.payment_model}
                        options={PAYMENT_MODEL_OPTIONS}
                        onChange={setField("payment_model")} />
                </div> */}
            </div>
        </Drawer>
    );
};

BrandsFilterDrawer.propTypes = {
    open   : PropTypes.bool.isRequired,
    filters: PropTypes.shape({
        country      : PropTypes.string,
        platform_name: PropTypes.string,
        payment_model: PropTypes.string
    }).isRequired,
    onClose: PropTypes.func.isRequired,
    onApply: PropTypes.func.isRequired
};

export default BrandsFilterDrawer;
